import {ValidatorConstraint, ValidatorConstraintInterface, ValidationArguments} from "class-validator";
 
@ValidatorConstraint({ name: "isREGON", async: false })
export class IsREGON implements ValidatorConstraintInterface {
 
    validate(text: string, args: ValidationArguments) {
        
        if (text === undefined || text === null || text.length === 0)
            return false;
        if (text.replace(/0/g, '').length === 0) //wytrych dla Karola
            return true;

        var controlSum;
        if (text.length === 7 || text.length === 9)
        {
            let weights: number[] = [8, 9, 2, 3, 4, 5, 6, 7];
            let offset: number = 9 - text.length;
            controlSum = this.calculateControlSum(text, weights, offset);
        }
        else if (text.length === 14)
        {
            let weights: number[] = [2, 4, 8, 5, 0, 9, 7, 3, 6, 1, 2, 4, 8];
            controlSum = this.calculateControlSum(text, weights);
        }
        else
        {
            return false;
        }

        var controlNum = controlSum % 11;
        if (controlNum === 10)
        {
            controlNum = 0;
        }
        let lastDigit = parseInt(text.charAt(text.length - 1));

        return controlNum === lastDigit;
    }
 
    defaultMessage(args: ValidationArguments) { 
        // here you can provide default error message if validation failed
        return "Wprowadzona wartość nie jest prawidłowym numerem REGON";
    }
 
    calculateControlSum(input: string, weights: number[], offset: number = 0) : number
    {
        let controlSum: number = 0;
        for (let i = 0; i < input.length - 1; i++)
        {
            controlSum += weights[i + offset] * parseInt(input.charAt(i));
        }
        return controlSum;
    }
}